<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('deliveryOrder.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('deliveryOrder.pageTitle'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div
          class="d-flex justify-content-between ts-items-center ts-whitespace-no-wrap ts-space-x-3"
        >
          <div class="ts-flex ts-items-center ts-space-x-3">
            <ts-button outline color="info" @click.prevent="addNew">
              {{ $t('add_new') }}
            </ts-button>
            <a-range-picker
              v-model="dateRange"
              :allowClear="false"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              style="width: 200px"
              @change="fetchData()"
            />
          </div>
          <div class="d-flex ts-space-x-3 ts-items-center">
            <ts-input
              v-tooltip="$t('deliveryOrder.search')"
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
            <ts-filter ref="filter">
              <div class="row">
                <div class="col-md-12">
                  <label class="">{{ $t('deliveryOrder.branchName') }}</label>
                  <ts-branch-filter
                    @filter="branchFilter" 
                    class="ts-w-full"
                  ></ts-branch-filter>
                </div>
              </div>
            </ts-filter>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
        >
          <template v-slot="{ record }">
            <td>{{ record.branch.branch_name_en }}</td>
            <td>{{ record.do_date }}</td>
            <td>{{ record.do_number }}</td>
            <td>{{ join(uniq(record.view_details.map(el => el.invoice_no)), ', ') }}</td>
            <td>{{ join(uniq(record.view_details.map(el => el.customer_name)), ', ') }}</td>
            <td>{{ record.seller.employee_name_en }}</td>
            <td>{{ record.remarks }}</td>
            <td>{{ record.user.name }}</td>
						<td class="text-center ts-space-x-3">
                            <a
                href="#"
                v-tooltip="$t('deliveryOrder.reprint')"
                class="text-primary text-red"
                @click.prevent="previewPdf(record)"
              >
                <i class="fas fa-file-pdf"></i>
              </a>

							<a href="#" v-tooltip="$t('edit')" class="text-primary" @click.prevent="edit(record)">
								<i class="fas fa-edit"></i>
							</a>
							<a-popconfirm
								placement="leftTop"
								:title="$t('are_you_sure_to_delete')"
								:ok-text="$t('yes')"
								:cancel-text="$t('no')"
								@confirm="deleteRecord(record)"
							>
								<a href="#" :disabled="record._deleting">
									<i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
									<i class="fa fa-trash text-red" v-else></i>
								</a>
							</a-popconfirm>
						</td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
      <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :footer="null">
        <ts-preview-pdf v-model="waiting" :src="src" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import { uniq, join } from 'lodash'

export default {
  name: 'deliveryOrder',
  data() {
    return {
      loading: false,
      waiting: false,
      src: null,
      show_pdf: false,
			model: {}
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('wholesale/deliveryOrder', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.wholesale.deliveryOrder.search
      },
      set(newValue) {
        this.$store.commit('wholesale/deliveryOrder/SET_SEARCH', newValue)
        this.$store.commit('wholesale/deliveryOrder/RESET_CURRENT_PAGE')
      },
    },
    dateRange: {
      get() {
        return this.$store.state.wholesale.deliveryOrder.dateRange
      },
      set(newValue) {
        this.$store.commit('wholesale/deliveryOrder/SET_DATE_RANGE', newValue)
      },
    },
    columns() {
      return [
        { name: this.$t('deliveryOrder.branchName') },
        { name: this.$t('deliveryOrder.doDate') },
        { name: this.$t('deliveryOrder.doNumber') },
        { name: this.$t('deliveryOrder.invoice#') },
        { name: this.$t('deliveryOrder.customer') },
        { name: this.$t('deliveryOrder.seller') },
        { name: this.$t('deliveryOrder.remark') },
        { name: this.$t('deliveryOrder.createdBy') },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width:7%',
        },
      ]
    },
  },
  methods: {
    addNew() {
      this.$router.push({ name: 'delivery-order-create' })
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('wholesale/deliveryOrder/fetch', { ...attributes })
        .then((response) => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch('wholesale/deliveryOrder/destroy', record.do_id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
		edit(record){
      this.$store.commit('wholesale/deliveryOrder/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'delivery-order-edit',
        params: { id: record.do_id },
      })
		},
    branchFilter(value){
      this.$store.commit('wholesale/deliveryOrder/SET_BRANCH_ID', value)
      this.fetchData()
    },
    previewPdf(record) {
      this.show_pdf = true
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('wholesale/deliveryOrder/previewPdf', record.do_id)
        .then((response) => {
          this.src = response.url
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    uniq,
    join
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500),
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('wholesale/deliveryOrder/RESET_STATE')
    next()
  },
}
</script>